import { render, staticRenderFns } from "./mawbNoInput.vue?vue&type=template&id=fa63a836&"
import script from "./mawbNoInput.vue?vue&type=script&lang=js&"
export * from "./mawbNoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa63a836')) {
      api.createRecord('fa63a836', component.options)
    } else {
      api.reload('fa63a836', component.options)
    }
    module.hot.accept("./mawbNoInput.vue?vue&type=template&id=fa63a836&", function () {
      api.rerender('fa63a836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/mawbNoInput.vue"
export default component.exports